export const riskManagementProfilesArticle = {
  title: 'Risk Management: Risk Profiles',
  slug: 'risk-management-profiles',
  content: `Risk Management: Risk Profiles

Create and maintain your risk register.

1) Open Risk Manager
- Go to /finance/risk-manager.

2) Add a risk
- Click Add Risk to open the form.
- Provide title, source, level, impact, probability, and mitigation plan.

3) Edit or delete risks
- Use the edit action on a profile to update details.
- Delete risks when no longer relevant.

4) Track mitigation status
- Set mitigation status and deadlines to keep owners aligned.
`,
};
